module.exports = __webpack_public_path__ + "img/404.ca656c41.svg";